import HeroSection from "../components/Services/HeroSection";
import Features from "../components/Services/Features";
import { ServicesData } from "../Data/ServicesData";

const Services = () => {
  return (
    <div>
      <HeroSection />
      <div className="flex flex-col justify-center items-center font-poppins mt-[30px] px-[20px] sm:px-[100px] lg:py-[50px]">
        <p className="text-[#248493] text-level-6 lg:text-level-2 xl:text-4xl font-semibold text-center xl:mb-[30px]">
          {" "}
          Care through strength and support
        </p>
        <div className="text-[#6A6868] text-level-7 lg:text-lg xl:text-xl max-w-[1240px] font-light text-center">
          <p>
            At Roselea Care Homes, we specialise in providing high quality,
            person centred care for individuals with learning disabilities (LD),
            autism spectrum disorder (ASD), and mental health (MH) needs.
          </p>
          <p>
            Our services are designed to empower individuals to live fulfilling,
            independent lives while receiving the support they need in a safe
            and nurturing environment.
          </p>
        </div>
      </div>

      {ServicesData?.map((item) => (
        <Features key={item.id} service={item} />
      ))}
    </div>
  );
};

export default Services;
